import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import consts from "../consts";

// import CustomNavbar from "../common/CustomNavbar";
// import Footer from "../common/Footer";
import Footer from "../common/FooterBar";
import LegalFooter from "../common/LegalFooter";
import CustomNavbar from "../common/NaveBar";
import PublicRoute from "./PublicRoute";

// ✅ Lazy loading - ໂຫຼດ page ເມື່ອ user ເຂົ້າເທົ່ານັ້ນ (ຫຼຸດ initial bundle 50-70%)
const Home = React.lazy(() => import("../pages/home/Home"));
const GameDetail = React.lazy(() => import("../pages/game/GameDetail"));
const Login = React.lazy(() => import("../pages/loginAndRegister/Login"));
const Register = React.lazy(() => import("../pages/loginAndRegister/Register"));
const HistoryGameInvoice = React.lazy(() => import("../pages/history/HistoryGameInvoice"));
const HistoryVoucherInvoice = React.lazy(() => import("../pages/history/HistoryVoucherInvoice"));
const Profile = React.lazy(() => import("../pages/profile/Profile"));
const ChangePassword = React.lazy(() => import("../pages/profile/ChangePassword"));
const ResetPassword = React.lazy(() => import("../pages/loginAndRegister/resetPassword"));
const RechargeList = React.lazy(() => import("../pages/recharge/RechargeList"));
const HistoryRecharge = React.lazy(() => import("../pages/history/HistoryRecharge"));
const Recharge2Page = React.lazy(() => import("../pages/recharge2/Recharge2Page"));
const PrizeWheel = React.lazy(() => import("../pages/prizeWheel/PrizeWheel"));
const GameVerifyPage = React.lazy(() => import("../pages/gameVerify/GameVerifyPage"));

// Legal pages
const AboutUs = React.lazy(() => import("../pages/legal/AboutUs"));
const ContactUs = React.lazy(() => import("../pages/legal/ContactUs"));
const PrivacyPolicy = React.lazy(() => import("../pages/legal/PrivacyPolicy"));
const TermsOfService = React.lazy(() => import("../pages/legal/TermsOfService"));
const RefundPolicy = React.lazy(() => import("../pages/legal/RefundPolicy"));

// Loading spinner ລະຫວ່າງ lazy load
const PageLoader = () => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "60vh" }}>
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

function RouterLink() {
  return (
    <>
      <Router>
        <Switch>
          <Route
            render={({ location, history }) => (
              <React.Fragment>
                <CustomNavbar />
                <Suspense fallback={<PageLoader />}>
                <PublicRoute
                  path={`${consts.LOGIN}`}
                  component={Login}
                  exact
                />
                <PublicRoute path="/" component={Home} exact />
                <PublicRoute
                  path={`${consts.REGISTER}`}
                  component={Register}
                  exact
                />
                <PublicRoute
                  path={`${consts.RESET_PASSWORD}`}
                  component={ResetPassword}
                  exact
                />
                <PublicRoute
                  path={`${consts.PROFILE}`}
                  component={Profile}
                  exact
                />
                <PublicRoute
                  path={`${consts.CHANGE_PASSWORD}/:id`}
                  component={ChangePassword}
                  exact
                />
                <PublicRoute
                  path={`${consts.RECHARGE_2}`}
                  component={Recharge2Page}
                  exact
                />
                <PublicRoute
                  path={`${consts.RECHARGE}`}
                  component={RechargeList}
                  exact
                />
                <PublicRoute
                  path={`${consts.HISTORY_GAME_INVOICE}/limit/:limit/skip/:skip`}
                  component={HistoryGameInvoice}
                  exact
                />
                <PublicRoute
                  path={`${consts.HISTORY_VOUCHER_INVOICE}/limit/:limit/skip/:skip`}
                  component={HistoryVoucherInvoice}
                  exact
                />
                <PublicRoute
                  path={`${consts.GAME_DETAIL}/:id/:type`}
                  component={GameDetail}
                  exact
                />
                <PublicRoute
                  path={`${consts.HISTORY_RECHARGE}/limit/:limit/skip/:skip`}
                  component={HistoryRecharge}
                  exact
                />
                <PublicRoute
                  path={`${consts.PRIZE_WHEEL}`}
                  component={PrizeWheel}
                  exact
                />
                <PublicRoute
                  path={`${consts.GAME_VERIFY}`}
                  component={GameVerifyPage}
                  exact
                />
                {/* Legal / Trust Pages */}
                <PublicRoute
                  path={`${consts.ABOUT}`}
                  component={AboutUs}
                  exact
                />
                <PublicRoute
                  path={`${consts.CONTACT}`}
                  component={ContactUs}
                  exact
                />
                <PublicRoute
                  path={`${consts.PRIVACY_POLICY}`}
                  component={PrivacyPolicy}
                  exact
                />
                <PublicRoute
                  path={`${consts.TERMS_OF_SERVICE}`}
                  component={TermsOfService}
                  exact
                />
                <PublicRoute
                  path={`${consts.REFUND_POLICY}`}
                  component={RefundPolicy}
                  exact
                />
                </Suspense>
                {/* <Footer /> */}
                <div className="desktop-spacer" style={{ height: "100px" }}></div>
                <LegalFooter />
                <Footer />
              </React.Fragment>
            )}
          />
        </Switch>
      </Router>
    </>
  );
}

export default RouterLink;
